/**
 * External dependencies
 */
// eslint-disable-next-line import/no-unresolved
import $ from 'jquery';
import VMasker from 'vanilla-masker';

if (null !== document.querySelector('form.woocommerce-checkout')) {
	// Show an element.
	const show = (elem) => {
		if (null !== elem) {
			elem.style.display = 'initial';
		}
	};

	// Hide an element.
	const hide = (elem) => {
		if (null !== elem) {
			elem.style.display = 'none';
		}
	};

	const customerDetails = document.querySelector('#customer_details');
	customerDetails.parentNode.removeChild(customerDetails);

	const woocommerceCheckoutCouponCode = document.querySelector(
		'.woocommerce-checkout-coupon-code'
	);
	hide(woocommerceCheckoutCouponCode);

	const woocommerceCheckoutPayment = document.querySelector(
		'.woocommerce-checkout-review-order'
	);
	hide(woocommerceCheckoutPayment);

	const pageCheckoutStep = document.querySelectorAll('.page-checkout__step');
	const checkSteps = () => {
		pageCheckoutStep.forEach((element) => {
			hide(element);
			if (element.classList.contains('active')) {
				show(element);
				window.scrollTo(0, 0);
			}
		});
	};

	checkSteps();

	const checkoutSteps = new Map();
	checkoutSteps.set('product-choice', 'checkout-steps--0');
	checkoutSteps.set('register-personal', 'checkout-steps--1');
	checkoutSteps.set('register-address', 'checkout-steps--2');
	checkoutSteps.set('register-login', 'checkout-steps--3');
	checkoutSteps.set('register-review', 'checkout-steps--4');
	checkoutSteps.set('payment', 'checkout-steps--5');

	const goToTarget = (target) => {
		if ('payment' === target) {
			document
				.querySelector('body')
				.dispatchEvent(new Event('update_checkout'));
		}

		for (let i = 0; i < pageCheckoutStep.length; i++) {
			pageCheckoutStep[i].classList.remove('active');
		}

		document
			.querySelector('.page-checkout__step--' + target)
			.classList.add('active');

		const steps = checkoutSteps.get(target);
		document
			.querySelector('.checkout-steps')
			.setAttribute('class', 'checkout-steps ' + steps);

		if ('payment' === target) {
			show(woocommerceCheckoutCouponCode);
			show(woocommerceCheckoutPayment);
		} else {
			hide(woocommerceCheckoutCouponCode);
			hide(woocommerceCheckoutPayment);
		}
		checkSteps();
	};

	/**
	 * Process form data to send via Ajax.
	 */
	const form = document.querySelector('form.woocommerce-checkout');
	const nextStep = document.querySelectorAll('.page-checkout__next-step');
	const prevStep = document.querySelectorAll('.page-checkout__prev-step');
	const notice = document.querySelector('.woocommerce-notice');

	prevStep.forEach((element) => {
		element.addEventListener('click', () => {
			const target = element.getAttribute('data-target');
			form.querySelector('input[name="target"]').value = target;
			if ('' !== notice.innerHTML) {
				notice.innerHTML = '';
			}
			goToTarget(target);
		});
	});

	nextStep.forEach((element) => {
		element.addEventListener('click', () => {
			const target = element.getAttribute('data-target');
			form.querySelector('input[name="target"]').value = target;

			const data = new FormData(form);
			const xhr = new XMLHttpRequest();

			xhr.onload = () => {
				const response = JSON.parse(xhr.responseText || '[]');
				if (response.success) {
					if ('' !== notice.innerHTML) {
						notice.innerHTML = '';
					}
					goToTarget(target);
					data.forEach((_element, j) => {
						if (null !== _element && '' !== _element) {
							const billingValue = document.querySelector(
								'.' + j + ' span'
							);
							if (null !== billingValue) {
								billingValue.innerHTML = _element;
							}
						}
					});
				} else {
					notice.innerHTML = response.data.message;
					window.scrollTo(0, 0);
				}
			};

			xhr.open(
				form.method,
				form.querySelector('input[name="_ajax_url"]').value
			);
			xhr.send(data);
		});
	});

	/**
	 * Change the visibility of form fields by type of person selected.
	 */
	const billingPersontype = document.querySelector(
		'select[name="billing_persontype"]'
	);
	const legalEntity = document.querySelectorAll(
		'.person-type .legal-entity, .register-review .billing_cnpj'
	);
	const naturalPerson = document.querySelectorAll(
		'.person-type .natural-person, .register-review .billing_cpf'
	);
	const billingPersontypeCheck = () => {
		const current = billingPersontype.value;
		legalEntity.forEach((element) => {
			hide(element);
		});
		naturalPerson.forEach((element) => {
			hide(element);
		});

		if ('1' === current) {
			naturalPerson.forEach((element) => {
				show(element);
			});
			return;
		}
		legalEntity.forEach((element) => {
			show(element);
		});
	};

	billingPersontypeCheck();

	billingPersontype.addEventListener('change', () => {
		billingPersontypeCheck();
	});

	document
		.querySelectorAll("label[for='billing_cpf'],label[for='billing_cnpj']")
		.forEach((element) => {
			element.insertAdjacentHTML(
				'beforeend',
				'<abbr class="required" title="' +
					// eslint-disable-next-line camelcase
					bmwPublicParams.required +
					'">*</abbr>'
			);
		});

	// Form Mask Vanilla Masker.
	const inputHandler = (masks, max, event) => {
		const c = event.target;
		const v = c.value.replace(/\D/g, '');
		const m = c.value.length > max ? 1 : 0;
		VMasker(c).unMask();
		VMasker(c).maskPattern(masks[m]);
		c.value = VMasker.toPattern(v, masks[m]);
	};

	const billingBirthdate = document.querySelector(
		'input[name="billing_birthdate"]'
	);
	const billingFone = document.querySelector('input[name="billing_phone"]');
	const phoneMask = ['(99) 9999-99999', '(99) 99999-9999'];

	VMasker(billingBirthdate).maskPattern('99/99/9999');
	VMasker(billingFone).maskPattern(phoneMask[0]);
	billingFone.addEventListener(
		'input',
		inputHandler.bind(undefined, phoneMask, 14),
		false
	);

	// Products choice.
	const productId = document.querySelectorAll('input[name="product_id"]');
	const variationId = document.querySelectorAll('input[name="variation_id"]');
	const changeProduct = (element) => {
		const current = element.getAttribute('data-product-parent');
		productId.forEach((item) => {
			item.disabled = true;
			if (item.value === current) {
				item.disabled = false;
			}
		});

		document.querySelectorAll('.products-list__item').forEach((item) => {
			item.classList.remove('active');
		});
		document.querySelector('#product-' + current).classList.add('active');
	};
	variationId.forEach((element) => {
		element.addEventListener('change', () => {
			changeProduct(element);
		});
	});

	// Disable form submit enter.
	$(document).on('keypress', 'form.woocommerce-checkout', (e) => {
		const code = e.keyCode || e.which;
		if (code === 13) {
			e.preventDefault();
			return false;
		}
	});
}
